import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Breadcrumb, Button, Spinner } from 'react-bootstrap';
import GameSessionManagement from '../components/GameSession/GameSessionManagement';

const GameSessionsPage: React.FC = () => {
  const { gameSpaceId } = useParams<{ gameSpaceId: string }>();
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  if (!gameSpaceId) {
    return (
      <Container className="mt-4">
        <div className="alert alert-danger">
          No game space ID provided. Please select a game space.
        </div>
        <Button variant="primary" onClick={() => navigate('/game/spaces')}>
          View Game Spaces
        </Button>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <Breadcrumb className="mb-4">
        <Breadcrumb.Item onClick={() => navigate('/')}>Home</Breadcrumb.Item>
        <Breadcrumb.Item onClick={() => navigate('/game/spaces')}>Game Spaces</Breadcrumb.Item>
        <Breadcrumb.Item active>Sessions</Breadcrumb.Item>
      </Breadcrumb>

      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <GameSessionManagement gameSpaceId={parseInt(gameSpaceId, 10)} />
      )}
    </Container>
  );
};

export default GameSessionsPage;
